import { memo, useCallback, useMemo } from 'react';

import { ExpirationDateRow } from '~/components/ShareModal/components/SecurityPrivacySection/ExpirationDateRow';
import { useShowcaseModal } from '~/components/ShowcaseModal/ShowcaseModalContext';
import { buildDraftShortIdInfo } from '~/components/ShowcaseModal/utils';

/** Create-mode smart leaf: expiration date row driven by a synthetic draft `shortIdInfo`. */
export const CreateShowcaseSettingsExpirationRow = memo(() => {
  const { shortUrlProps, updateExpirationDate } = useShowcaseModal();

  const draftShortIdInfo = useMemo(
    () =>
      buildDraftShortIdInfo(
        shortUrlProps.passcode,
        shortUrlProps.disabled,
        shortUrlProps.expirationDate,
        shortUrlProps.permissions,
        shortUrlProps.presentationSettings,
      ),
    [
      shortUrlProps.passcode,
      shortUrlProps.disabled,
      shortUrlProps.expirationDate,
      shortUrlProps.permissions,
      shortUrlProps.presentationSettings,
    ],
  );

  const handleChangeExpirationDate = useCallback(
    async (expirationDate: string | null) => {
      updateExpirationDate(expirationDate);
    },
    [updateExpirationDate],
  );

  return (
    <ExpirationDateRow
      shortIdInfo={draftShortIdInfo}
      onChangeExpirationDate={handleChangeExpirationDate}
      hideSaveButton
    />
  );
});

CreateShowcaseSettingsExpirationRow.displayName = 'CreateShowcaseSettingsExpirationRow';
